import React, { Component, createContext } from 'react';

// 创建Context
const ChatContext = createContext();

export class ChatProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageQueue: {}
        };
    }

    // Method to initialize a chat window with a specific key  
    initializeChat = (key) => {
        if (!this.state.messageQueue[key]) {
            this.setState(prevState => ({
                messageQueue: {
                    ...prevState.messageQueue,
                    [key]: {
                        messages: [],
                        disabledButtons: {},
                        nextMessageId: 1,
                    }
                }
            }));
        }
    }

    // 方法：添加消息到状态
    addMessage = (key, message, btnIndex = null) => {
        this.setState(prevState => {
            const chatState = prevState.messageQueue[key] || {
                messages: [],
                disabledButtons: {},
                nextMessageId: 1,
            };

            const newMessageId = chatState.nextMessageId;
            const newMessage = { ...message, messageId: newMessageId };
            const newMessages = [...chatState.messages, newMessage];
            const newDisabledButtons = { ...chatState.disabledButtons };

            // 检查并更新上一条消息的按钮禁用状态  
            if (chatState.messages.length > 0) {
                const lastMessage = chatState.messages[chatState.messages.length - 1];
                if (this.hasButtons(lastMessage)) {
                    if (btnIndex !== null) {
                        // 更新按钮的 clicked 状态  
                        lastMessage.buttons = lastMessage.buttons.map((button, index) => ({
                            ...button,
                            clicked: index === btnIndex
                        }));
                    }
                    
                    newDisabledButtons[lastMessage.messageId] = true;
                }
            }

            // 如果新消息有按钮，添加对应的禁用状态  
            if (this.hasButtons(newMessage)) {
                newDisabledButtons[message.messageId] = false;
            }

            return {
                messageQueue: {
                    ...prevState.messageQueue,
                    [key]: {
                        messages: newMessages,
                        disabledButtons: newDisabledButtons,
                        nextMessageId: newMessageId + 1,
                    }
                }

                //messages: newMessages,
                //disabledButtons: newDisabledButtons,
                //nextMessageId: prevState.nextMessageId + 1
            };
        });
    };

    getMessages = (key) => {
        const chatState = this.state.messageQueue[key];
        return chatState ? chatState.messages : [];

        //const chatState = this.state.messageQueue[key] || {
        //    messages: [],
        //    disabledButtons: {},
        //    nextMessageId: 1,
        //};
        //return chatState.messages;
        //return this.state.messages
    }

    addWithoutLastMessageList = (key, message, num) => {
        if (num !== undefined) {
            this.setWithoutLastMessageList(key, num);
        }

        this.addMessage(key, message);
    }

    setWithoutLastMessageList = (key, num) => {
        this.setState(prevState => {
            const chatState = prevState.messageQueue[key] || {
                messages: [],
                disabledButtons: {},
                nextMessageId: 1,
            };

            return {
                messageQueue: {
                    ...prevState.messageQueue,
                    [key]: {
                        ...chatState,
                        messages: chatState.messages.slice(0, num),
                    }
                }
            };
        }); 

        //this.setState(prevState => ({
        //    messages: prevState.messages.slice(0, num)
        //}));
    }

    //getWithoutLastMessageList = (key, num) => {
    //    if (num !== undefined) {
    //        this.setWithoutLastMessageList(key, num)
    //    }

    //    return this.getMessages(key);
    //}

    

    //updateMessages = messages => {
    //    this.setState({ messages })
    //}

    // Helper function to check if a message has buttons  
    hasButtons = (message) => {
        return message.buttons && message.buttons.length > 0;
    }

    // Method to disable buttons of the last message if it has buttons  
    disableLastMessageButtons = (key, btnIndex = null) => {
        this.setState(prevState => {
            const chatState = prevState.messageQueue[key] || {
                messages: [],
                disabledButtons: {},
                nextMessageId: 1,
            };

            const newDisabledButtons = { ...chatState.disabledButtons };

            if (chatState.messages.length > 0) {
                const lastMessage = chatState.messages[chatState.messages.length - 1];
                if (this.hasButtons(lastMessage)) {
                    if (btnIndex !== null) {
                        // 更新按钮的 clicked 状态  
                        lastMessage.buttons = lastMessage.buttons.map((button, index) => ({
                            ...button,
                            clicked: index === btnIndex
                        }));
                    }

                    newDisabledButtons[lastMessage.messageId] = true;
                }
            }

            return {
                messageQueue: {
                    ...prevState.messageQueue,
                    [key]: {
                        ...chatState,
                        disabledButtons: newDisabledButtons,
                    }
                }
            };
            //return { disabledButtons: newDisabledButtons };
        });
    }

    render() {
        return (
            <ChatContext.Provider value={{
                messageQueue: this.state.messageQueue,
                initializeChat: this.initializeChat,
                addMessage: this.addMessage,
                addWithoutLastMessageList: this.addWithoutLastMessageList,
                setWithoutLastMessageList: this.setWithoutLastMessageList,
                getMessages: this.getMessages,
                //getWithoutLastMessageList: this.getWithoutLastMessageList,
                //updateMessages: this.updateMessages,
                disableLastMessageButtons: this.disableLastMessageButtons
            }}>
                {this.props.children}
            </ChatContext.Provider>
        );
    }
}

export const ChatConsumer = ChatContext.Consumer;
export default ChatContext;
